module.exports = __webpack_public_path__ + "static/media/message.f0e50a0.wav";


//////////////////
// WEBPACK FOOTER
// ./static/media/message.wav
// module id = Y13x
// module chunks = 1